import { render } from "./chevron-right-thin.vue?vue&type=template&id=2b94b1c0"
import script from "./chevron-right-thin.vue?vue&type=script&lang=js"
export * from "./chevron-right-thin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__